export default {
  title: "All Visits",
  subtitle: "View and manage all patient visits",
  comingSoon: "Coming Soon",
  description: "This feature will allow you to view and manage all patient visits in one place.",
  copied: "Copied to clipboard",
  gender: {
    male: "Male",
    female: "Female",
  },
  actions: {
    filter: "Filter visits",
    refresh: "Refresh",
    viewResults: "View results",
    downloadPdf: "Download PDF",
  },
  table: {
    id: "ID",
    idTooltip: "Visit number",
    copyId: "Copy visit ID",
    date: "Date / Time",
    dateTooltip: "Date and time of the visit",
    pid: "PID",
    patient: "Patient",
    readiness: "Readiness",
    readinessTooltip: "{percent}% ready",
    flags: "Flags",
    actionsTitle: "Actions",
    flagsTooltipSingular: "Quick overview - {count} flagged",
    flagsTooltipPlural: "Quick overview - {count} flagged",
    openRecord: "Open patient record",
    test: "Test",
    result: "Result",
    flag: "Flag",
    units: "Units",
    refRange: "Ref. range",
    itemsPerPage: "Items per page",
  },
  preview: {
    toggle: "Preview",
    newTab: "in new tab",
    currentTab: "in current tab",
  },
  filters: {
    title: "Filter visits",
    subtitle: "Build conditions to narrow down the visit list",
    field: "Field",
    fieldPlaceholder: "Select a field",
    fieldHint: "Visit field to filter by",
    fieldRequired: "Select a field",
    operator: "Match type",
    operatorHint: "How to compare visit data",
    operatorRequired: "Select a match type",
    value: "Value",
    valuePlaceholder: "Enter a value",
    valueHint: "Value to match in visits",
    valueRequired: "Enter a value",
    add: "Add condition",
    addAnother: "Add condition",
    addFirst: "Add your first condition",
    apply: "Apply filters",
    save: "Save",
    clearAll: "Clear all",
    andConnector: "AND",
    emptyTitle: "No conditions added",
    emptyDescription: "Add filter conditions to narrow down the visits displayed in the table.",
    empty: "No filters yet. Add one to narrow down the list.",
    preview: "FQL preview",
    fqlPreviewBtn: "Show FQL",
    fqlPreviewTitle: "FQL Query",
    removeRow: "Remove condition",
    clearAllTooltip: "Remove all conditions",
    addFilterTooltip: "Add a condition",
    fields: {
      givenName: "First name",
      middleName: "Middle name",
      familyName: "Last name",
      patientId: "PID",
      gender: "Gender",
      dateOfBirth: "Date of birth",
      date: "Visit date",
    },
    operators: {
      cn: "Contains",
      sw: "Starts with",
      ew: "Ends with",
      eq: "Equals",
    },
    booleanValues: {
      true: "Male",
      false: "Female",
    },
    fieldHints: {
      givenName: "Patient's first (given) name",
      middleName: "Patient's middle name",
      familyName: "Patient's last (family) name",
      patientId: "National ID number (e.g. EGN / EMBG)",
      gender: "Biological sex of the patient",
      dateOfBirth: "Date format: YYYY-MM-DD",
      date: "Date format: YYYY-MM-DD",
    },
  },
  dialogs: {
    errors: {
      serverTitle: "Something went wrong",
      serverSubtitle: "Failed to load data. Please try again.",
      networkTitle: "Connection lost",
      networkSubtitle: "Unable to reach the server. Check your connection.",
      timeoutTitle: "Request timed out",
      timeoutSubtitle:
        "The request could not be processed in time. This is likely a temporary issue — please try again shortly.",
      authTitle: "Session expired",
      authSubtitle: "Please log in again to continue.",
      unknownTitle: "Unexpected error",
      unknownSubtitle: "Something went wrong. Please try again later.",
      retry: "Try again",
      login: "Log in",
    },
    results: {
      title: "Visit Results",
      subtitle: "Visit ID:",
      empty: "No results found",
      emptySubtitle: "This visit has no results to display.",
      history: "View test history",
      loading: "Loading visit results\u2026",
    },
    flags: {
      title: "Flagged Results",
      subtitle: "{count} flagged results",
      loading: "Loading flagged results\u2026",
    },
  },
  errors: {
    serverTitle: "Something went wrong",
    serverSubtitle: "Failed to load visits. Please try again.",
    networkTitle: "Connection lost",
    networkSubtitle: "Unable to reach the server. Please check your internet connection.",
    timeoutTitle: "Request timed out",
    timeoutSubtitle:
      "The request could not be processed in time. This is likely a temporary issue — please try again shortly.",
    authTitle: "Session expired",
    authSubtitle: "Please log in again to continue.",
    validationTitle: "Invalid filter",
    validationSubtitle: "The filter couldn't be processed. Please adjust and try again.",
    unknownTitle: "Unexpected error",
    unknownSubtitle: "Something went wrong. Please try again later.",
    emptyTitle: "No visits found",
    emptySubtitle: "No visits have been registered in the system yet.",
    filteredEmptyTitle: "No matching visits",
    filteredEmptySubtitle: "No visits match your current filters.",
    retry: "Try again",
    clearFilters: "Clear filters",
    editFilters: "Edit filters",
    login: "Log in",
    refreshFailed: "Could not refresh \u2014 showing last known results.",
  },
};
